// extracted by mini-css-extract-plugin
export default {"main":"card_main__MzbwT","row":"card_row__ykceF","label":"card_label__eQBuM","buttons":"card_buttons__HRpdq","button":"card_button__92DCC","button_main":"card_button_main__yfZQg"};